import { createContext, useContext, useRef } from "react";

export interface AgGridHandle {
  editOnline: () => void;
  save: () => Promise<any>;
  cancel: () => void;
  importFile: (file: File) => Promise<any>;
  exportFile: () => void;
  addRow: (count: number) => void;
  refetchData: () => Promise<void>;
  search: (value: string) => void;
}

const AgGridContext = createContext<any>(null);

export const useAgGridContext = () => {
  return useContext(AgGridContext);
};

export const AgGridProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const agGridRef = useRef<AgGridHandle | null>(null);

  return (
    <AgGridContext.Provider value={{ agGridRef }}>
      {children}
    </AgGridContext.Provider>
  );
};

export const fromOADate = (oaDate: number): Date => {
  const msPerDay = 86400000;
  const oaEpoch = new Date(1899, 11, 30).getTime();
  return new Date(oaEpoch + oaDate * msPerDay);
};

export const formatDateToDisplay = (date: Date) => {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export const formatDateToInput = (date: Date): string => {
  return date.toISOString().split("T")[0];
};
